export const PASSWORD_PATTERN = {
  pattern:
    /(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{8,16}/,
  message:
    'Password must contain one special character, one uppercase letter, one lowercase letter, one numeric symbol and must be at least 8 and no more than 16 characters',
};
